import mariana from '../../assets/about_images/mariana.png';
import eliska from '../../assets/about_images/eliska.png';
import marta from '../../assets/about_images/marta.png';
import nathalie from '../../assets/about_images/nathalie.png';
import klara from '../../assets/about_images/klara.png';
import katja from '../../assets/about_images/katja.jpg';

export const members = [
	{
		id: 1,
		name: 'Marta',
		intro:
		'Zdravím, jsem Marta mám ráda hudbu, kočky, tvoření a excel. Z aktivit Lesbotoče se specializuji na Speed dating, music quiz a podporu našich aktivit na pozadí. Na Lesbotoči se mi libí poznávání nových lidí, rozmanitost akcí a spolupráce s dalšími organizacemi.',
		img: marta,
	},
	{
		id: 2,
		name: 'Mariana',
		intro:
		'Nejsem moc dobrá v seznamování se online a v tom pro mě byl od začátku hlavní smysl Lesbotoče - poskytnout dalším holkám jako jsem já příležitost najít lásku nebo kamarádku v reálném životě. Na Lesbotoči mě nejvíc baví vymýšlení akcí a vedení filmového debatního klubu, kde konečně můžu prožívat bizardní i nebizardní lesbické filmy s dalšími lidmi.',
		img: mariana,
	},
	{
		id: 3,
		name: 'Eliška',
		intro:
		'Jsem Connection Creator týmu a zároveň spravuji sociální sítě, vytvářím příspěvky a snažím se rozšířit dosah naší skupiny. Je mi třicet, ráda vařím, peču a šiju. Pro moje Brownies cookies by leckdo šel světa kraj, přesto jsem šťastně zadaná tady s Mari, ale to nám nebrání vymýšlet dál aktivity a zajišťovat bezpečný prostor pro všechny lesby a bi holky, které se chtějí seznámit.',
		img: eliska,
	},
	{
		id: 4,
		name: 'Klára',
		intro:
		'Jsem kreativní krutopřísná kantorka :) Miluju kafe, kočky, kytky, kántrysajd, knihy a knihkupectví (a papírnictví). Jsem srdcem Lesbotočího knižního klubu.',
		img: klara,
	},
	{
		id: 5,
		name: 'Nathalie',
		intro:
		'Ahoj, jsem Nathalie a mám ráda batáty. Baví mě jezdit na kole v přírodě a plavat. Ráda trávím čas s knížkou v klíně. Pomáhám s organizací některých akcí Lesbotoče.',
		img: nathalie,
	},
	{
		id: 6,
		name: 'Katja',
		intro:
		'Ahoj, I\'m Katja. When I\'m not busy charming the bits and bytes of Lesbotoč Front- and Backend, I might be trying to win a board game. Despite the stereotype, I love coding AND humans.',
		img: katja,
	},
];
